import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import OnboardingQuiz from './components/OnboardingQuiz';
import Home from './pages/Home';
import ClubDirectory from './pages/ClubDirectory';
import ClubProfile from './pages/ClubProfile';
import CreateClub from './pages/CreateClub';
import TodayRuns from './pages/TodayRuns';
import AuthPage from './pages/AuthPage';
import AuthCallback from './pages/AuthCallback';
import ProfilePage from './pages/ProfilePage';
import MyClubsPage from './pages/MyClubsPage';
import ManageRoutes from './pages/ManageRoutes';
import ManageRunInstances from './pages/ManageRunInstances';
import ConfirmAttendance from './pages/ConfirmAttendance';
import AttendingPage from './pages/AttendingPage';
import AdminPage from './pages/AdminPage';
import LeaderDashboard from './pages/LeaderDashboard';
import { Analytics } from '@vercel/analytics/react';
import { useAuth } from './context/AuthContext';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function OnboardingGate() {
  const { user, profile, loading } = useAuth();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);

  // Don't show on auth pages or if already dismissed this session
  const isAuthRoute = location.pathname.startsWith('/auth');
  if (isAuthRoute || dismissed || loading || !user) return null;

  // Show quiz only if profile is missing onboarding data
  const needsOnboarding =
    !profile?.neighborhood && !profile?.pace_range && !profile?.goals?.length;
  if (!needsOnboarding) return null;

  return <OnboardingQuiz onDone={() => setDismissed(true)} />;
}

export default function App() {
  return (
    <div className="min-h-screen bg-white text-black">
      <ScrollToTop />
      <Navbar />
      <OnboardingGate />

      <div className="pb-16 md:pb-0">
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/today" element={<TodayRuns />} />
        <Route path="/explore" element={<ClubDirectory />} />
        <Route path="/my-clubs" element={<MyClubsPage />} />

        <Route path="/clubs" element={<Navigate to="/explore" replace />} />
        <Route path="/clubs/:id" element={<ClubProfile />} />
        <Route path="/clubs/:id/edit" element={<CreateClub />} />
        <Route path="/clubs/:id/routes" element={<ManageRoutes />} />
        <Route path="/clubs/:id/instances" element={<ManageRunInstances />} />
        <Route path="/clubs/:id/confirm-attendance" element={<ConfirmAttendance />} />
        <Route path="/clubs/:clubId/runs/:runId/attending" element={<AttendingPage />} />

        <Route path="/create-club" element={<CreateClub />} />

        <Route path="/auth" element={<AuthPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/profile" element={<ProfilePage />} />

        <Route path="/dashboard" element={<LeaderDashboard />} />
        <Route path="/admin" element={<AdminPage />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      </div>
      <Analytics />
    </div>
  );
}
